import { FC, useState } from 'react';
import CSVConfigurer from './CSVConfigurer';
import SFTPConfigurer from './SFTPConfigurer';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { AccordionStyled, ConfigurationsContainer } from './styled';

interface ICsvAccordion {
    customerUID: string;
    token: string;
}

const Configurations: FC<ICsvAccordion> = ({ customerUID, token }) => {
    const [expanded, setExpanded] = useState<'DragAndDrop' | 'SFTP'>('DragAndDrop');
    const handleExpandedChange =
        (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
            if(panel === 'DragAndDrop') {
                setExpanded(isExpanded ? 'DragAndDrop' : 'SFTP');
            } else {
                setExpanded(isExpanded ? 'SFTP' : 'DragAndDrop');
            }
        };

    return (
        <ConfigurationsContainer>
            <AccordionStyled
                disableGutters
                expanded={expanded === 'DragAndDrop'}
                onChange={handleExpandedChange('DragAndDrop')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}

                >
                    Drag & Drop
                </AccordionSummary>
                <AccordionDetails>
                    <CSVConfigurer customerUID={customerUID} token={token} />
                </AccordionDetails>
            </AccordionStyled>
            <AccordionStyled
                disableGutters
                expanded={expanded === 'SFTP'}
                onChange={handleExpandedChange('SFTP')}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    SFTP Configuration
                </AccordionSummary>
                <AccordionDetails>
                    <SFTPConfigurer customerUID={customerUID} token={token} />
                </AccordionDetails>
            </AccordionStyled>
        </ConfigurationsContainer>
    );
};

export default Configurations;
